
















import { Vue, Component } from 'vue-property-decorator';
import { Emit, Watch } from '@samclick-commons';
import { _isEmpty, _includes } from '@samclick-lodash';

enum SamclickNumberType {
    NUMBER = 'number',
    STRING = 'string',
}

@Component({
  props: {
    value: {
      type: [String, Number],
    },
    allowedDecimal: {
      type: Boolean,
      default: false,
    },
    showControls: {
      type: Boolean,
      default: true,
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    step: {
      type: Number,
    },
    precision: {
      type: Number,
      default: 2,
    },
    returnType: {
      type: String,
      default: SamclickNumberType.NUMBER,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
})
export class SamclickNumber extends Vue {
    temp = ''

    @Watch('$props.value', { immediate: true })
    valWatcher(newVal: string, oldVal: string) {
      this.temp = newVal;
    }

    @Emit('input')
    input(e:any) {
      return e;
    }

    @Emit('change')
    change(e:any) {
      return e;
    }

    @Emit('blur')
    blur(e:any) {
      let { value } = e.target;
      const {
        allowedDecimal, precision, allowEmpty, min, max, returnType,
      } = this.$props;

      if (allowedDecimal && value && _includes(value, '.')) {
        value = parseFloat(value).toFixed(precision);
      } else if (!allowedDecimal && value) {
        value = parseInt(value).toString();
      }

      if (!allowEmpty && (value === '' || value === null || value === undefined)) {
        if (min) {
          value = min.toString();
        } else {
          value = '0';
        }
      }

      if (!isNaN(min) && value && (Number(value) < min)) {
        value = returnType === SamclickNumberType.NUMBER ? min : min.toString();
      } else if (!isNaN(max) && value && (Number(value) > max)) {
        value = returnType === SamclickNumberType.NUMBER ? max : max.toString();
      }

      if (returnType === SamclickNumberType.NUMBER) {
        value = Number(value);
      }

      this.input(value);
      e.target.value = value;
      return e;
    }

    @Watch('$props', { immediate: true })
    validateProps() {
      const {
        allowEmpty, value, returnType,
      } = this.$props;
      if (!allowEmpty && (value === '' || value === null || value === undefined)) {
        throw new TypeError('Must have value if not allow an empty');
      }

      if (returnType === SamclickNumberType.NUMBER && allowEmpty) {
        throw new TypeError('Return Type must be string if empty is allowed');
      }
    }

    isNumber(evt: any) {
      evt = (evt) || window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;

      if (this.$props.allowedDecimal) {
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 45 && charCode !== 46) {
          evt.preventDefault();
        }
      } else if (!this.$props.allowedDecimal) {
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 45) {
          evt.preventDefault();
        }
      }
    }

    validatePaste(evt: any) {
      const data = evt.clipboardData.getData('text');
      evt = (evt) || window.event;
      if (_isEmpty(data) || isNaN(data)) {
        evt.preventDefault();
      }
    }


    get defaultAttrs() {
      return {
        size: 'small',
        min: this.$props.min,
        max: this.$props.max,
        step: this.$props.step,
      };
    }

    get overrideAttrs() {
      return this.defaultAttrs;
    }

    mounted() {
      this.temp = this.$props.value;
    }
}

export { SamclickNumberType };
export default SamclickNumber;

